if (!customElements.get('pdp-custom-subscription')) {
  customElements.define(
    'pdp-custom-subscription',
    class CustomSubscription extends HTMLElement {
      constructor() {
        super();
        this.subscriptionData = {};
        this._bundleCollectionSize = '';
        this.planVariantId = '';
        this.extraProductId = '';
        this.sellingPlanId = '';
        this.addGift = "false";

        this.step1 = this.querySelector('.js-subscription-step-box');
        this.step2 = this.querySelectorAll('.js-subscription-step-name');
        this.step3 = this.querySelector('.js-step-size');
        // this.step4 = this.querySelector('.js-subscription-step-breed');
        this.step5 = this.querySelector('.js-step-dob');
        this.step6 = this.querySelector('.js-step-allergies');
        this.step7 = this.querySelector('.js-step-email');
        this.step8 = this.querySelector('.js-step-plan');
        this.step9 = this.querySelector('.js-step-extra');
        this.allSteps = this.querySelectorAll('.js-subscription-item');

        this.currURL = window.location.href;
        this.subscriptionSteps();

        this.submitButton = document.querySelector('.js-pdp-complete-sub-btn');
        if(this.submitButton) this.submitButton.addEventListener('click', this.handleSubmit.bind(this));

        if(window.matchMedia('(max-width: 999px)').matches){
          this.selectedIndex = 0;
          this.mobileBundleInit();
        }
        else{
          this.submitButton.classList.remove('hide');
        }

        this.currentQuiz = this.step1.querySelector('.js-box-type.box-active')?.getAttribute('data-url-param');
      }

      set bundleCollectionSize(size) {
        this._bundleCollectionSize = size;
        this.updatePlans();
      }

      get bundleCollectionSize() {
        return this._bundleCollectionSize;
      }

      subscriptionSteps() {
        this.initialRedirection();
        this.boxType();
        this.InputQuizField();
        this.boxSize();
        // this.breedType();
        this.dateOfBirth();
        this.dogfAllergies();
        this.emailField();
        this.updatePlans();
        this.selectExtra();
        if(!window.matchMedia('(max-width: 999px)').matches){
          this.handleNewsletter('.js-desktop-newsletter-checkbox');
        }
      }

      initialRedirection() {
        const storedValue = sessionStorage.getItem("theme:mobile-subscription-selection");
        if (storedValue) {
          const selectedBox = this.step1.querySelector(`[data-current-sub="${storedValue}"]`);
          const nextStepBtn = this.step1.querySelector('.js-next-button');
      
          if (selectedBox) {
            selectedBox.classList.add('box-active');
            const boxes = this.step1.querySelectorAll('.js-box-type');
            boxes.forEach(box => {
              if (box !== selectedBox) box.classList.remove('box-active');
            });

            // if(window.matchMedia('(max-width: 999px)').matches && nextStepBtn){
            //   let nextSlide = nextStepBtn.getAttribute('data-next');
            //   setTimeout(() => {
            //     let nextStep = document.querySelector(`.js-slider-dots[data-dot-index="${nextSlide}"]`);
            //     nextStep.click();
            //   }, 400);
            // }

            if(window.matchMedia('(max-width: 999px)').matches) {
              this.closest('safe-sticky').scrollIntoView({ behavior: "smooth", block: "start" });
            }
            
            sessionStorage.removeItem("theme:mobile-subscription-selection");
          }
        }
      }

      boxType() {
        if (!this.step1) return;
        
        let boxes = this.step1.querySelectorAll('.js-box-type');
        let nextStepBtn = this.step1.querySelector('.js-next-button');

        if (!boxes.length) return;
        
        boxes.forEach((box) => {
          box.addEventListener('click', (e) => {
            boxes.forEach((boxItem) => boxItem.classList.remove('box-active'));
            box.classList.add('box-active');

            if(this.step1.classList.contains('error-present')){
              this.removeError(this.step1);
            }

            if(box.getAttribute("href") == "#"){
              e.preventDefault();
              // if(window.matchMedia('(max-width: 999px)').matches && nextStepBtn){
              //   let nextSlide = nextStepBtn.getAttribute('data-next');
              //   setTimeout(() => {
              //     let nextStep = document.querySelector(`.js-slider-dots[data-dot-index="${nextSlide}"]`);
              //     nextStep.click();
              //   }, 400);
              // }
            }
            else {
              let currentSelection = box.getAttribute('data-current-sub');
              sessionStorage.setItem("theme:mobile-subscription-selection", currentSelection);
            }
            
          });
        });
      }

      InputQuizField() {
        if (this.step2.length < 1) return;

        this.step2.forEach((currStep) => {
          let inputQuizField = currStep.querySelector('.js-input-quiz-field');
          let lineItemProp = currStep.getAttribute('data-line-item-property') || "Quiz field";
          let nextStepBtn = currStep.querySelector('.js-next-button');
        
          if (!inputQuizField) return;

          inputQuizField.addEventListener('input', () => {
            let quizValue = inputQuizField.value.trim();
            if (quizValue !== "") {
              this.subscriptionData[`${lineItemProp}`] = quizValue;
              if(currStep.classList.contains('error-present')){
                this.removeError(currStep);
              }
            }
          });
        })
        
        // let dogNameField = this.step2.querySelector('.js-dog-name-field');
        // let nextStepBtn = this.step2.querySelector('.js-next-button');

        // if (!dogNameField) return;
        
        // dogNameField.addEventListener('input', () => {
        //   let pupsName = dogNameField.value.trim();
        //   if (pupsName !== "") {
        //     this.subscriptionData["Pup's Name"] = pupsName;
        //     if(this.step2.classList.contains('error-present')){
        //       this.removeError(this.step2);
        //     }
        //   }
        // });
      }

      boxSize() {
        if (!this.step3) return;
        
        let sizeBoxes = this.step3.querySelectorAll('.js-bundle-size');
        let nextStepBtn = this.step3.querySelector('.js-next-button');

        if (!sizeBoxes.length) return;
        
        sizeBoxes.forEach((box) => {
          box.addEventListener('click', () => {
            sizeBoxes.forEach((boxItem) => boxItem.classList.remove('size-box-active'));
            box.classList.add('size-box-active');
            
            let boxSizeValue = box.querySelector('.box_title')?.innerHTML || "";
            let boxWeightValue = box.querySelector('.box_subtext')?.innerHTML || "";
            this.bundleCollectionSize = box.getAttribute('data-bundle-size');
            
            if(boxWeightValue) {
              this.subscriptionData["Size"] = `${boxSizeValue} | ${boxWeightValue}`.trim();
            }
            else {
              this.subscriptionData["Size"] = `${boxSizeValue}`.trim();
            }

            if(this.step8) {
              this.step8.querySelectorAll('.js-subscription-plan').forEach((plan) => {
                if(plan.classList.contains('plan-selected')) plan.classList.remove('plan-selected');
              });
            }

            if(this.step3.classList.contains('error-present')){
              this.removeError(this.step3);
            }

            // if(window.matchMedia('(max-width: 999px)').matches && nextStepBtn){
            //   let nextSlide = nextStepBtn.getAttribute('data-next');
            //   setTimeout(() => {
            //     let nextStep = document.querySelector(`.js-slider-dots[data-dot-index="${nextSlide}"]`);
            //     nextStep.click();
            //   }, 400);
            // }
          });
        });
      }

      // breedType() {
      //   if (!this.step4) return;
        
      //   let breedTypeField = this.step4.querySelector('.js-breed-type-field');
      //   let nextStepBtn = this.step4.querySelector('.js-next-button');

      //   if (!breedTypeField) return;
        
      //   breedTypeField.addEventListener('input', () => {
      //     if (breedTypeField.value.trim() !== "") {
      //       this.subscriptionData["Breed Type"] = breedTypeField.value.trim();
      //     }

      //     // if(this.step4.classList.contains('error-present')){
      //     //   this.removeError(this.step4);
      //     // }
      //   });

      //   // if(window.matchMedia('(max-width: 999px)').matches && nextStepBtn) {
      //   //   breedTypeField.addEventListener('keydown', (event) => {
      //   //     if (event.key === "Enter") {
      //   //       let nextSlide = nextStepBtn.getAttribute('data-next');
      //   //       setTimeout(() => {
      //   //         let nextStep = document.querySelector(`.js-slider-dots[data-dot-index="${nextSlide}"]`);
      //   //         if (nextStep) nextStep.click();
      //   //       }, 400);
      //   //     }
      //   //   });
      //   // }
      // }

      dateOfBirth() {
        if (!this.step5) return;
        
        let dobDayField = this.step5.querySelector('.js-dog-birthday');
        let dobMonthField = this.step5.querySelector('.js-dog-birthmonth');
        let dobYearField = this.step5.querySelector('.js-dog-birthyear');
        let nextStepBtn = this.step5.querySelector('.js-next-button');

        if (!dobDayField || !dobMonthField || !dobYearField) return;
        
        const validateDOB = () => {
          const dobDay = dobDayField.value.trim();
          const dobMonth = dobMonthField.value.trim();
          const dobYear = dobYearField.value.trim();
          const isValid = dobDay !== 'Day' && dobMonth !== 'Month' && dobYear !== 'Year';
          this.subscriptionData["Dog's Dob"] = isValid ? `${dobDay}-${dobMonth}-${dobYear}` : '';

          // if(this.step5.classList.contains('error-present') && isValid){
          //   this.removeError(this.step5);
          // }

          // if(window.matchMedia('(max-width: 999px)').matches && isValid && nextStepBtn){
          //   let nextSlide = nextStepBtn.getAttribute('data-next');
          //   setTimeout(() => {
          //     let nextStep = document.querySelector(`.js-slider-dots[data-dot-index="${nextSlide}"]`);
          //     nextStep.click();
          //   }, 400);
          // }
        };
        [dobDayField, dobMonthField, dobYearField].forEach(field =>
          field.addEventListener('change', validateDOB)
        );
        validateDOB();
      }

      dogfAllergies() {
        if (!this.step6) return;
        
        let allergyCheckboxes = this.step6.querySelectorAll('.js-allergy-checkbox');
        let noAllergyCheckbox = this.step6.querySelector('.js-no-allergy-checkbox');
        let otherAllergyCheckboxes = this.step6.querySelectorAll('.js-allergy-checkbox:not(.js-no-allergy-checkbox)');
        
        const updateAllergies = () => {
          this.subscriptionData["Allergies"] = Array.from(allergyCheckboxes)
            .filter(checkbox => checkbox.checked)
            .map(checkbox => checkbox.value)
            .join(', ');
        };
        
        const handleAllergyChange = (event) => {
          const clickedCheckbox = event.target;
          
          if (clickedCheckbox.classList.contains('js-no-allergy-checkbox')) {
            if (clickedCheckbox.checked) {
              otherAllergyCheckboxes.forEach(checkbox => {
                checkbox.checked = false;
              });
            }
          } else {
            if (clickedCheckbox.checked && noAllergyCheckbox) {
              noAllergyCheckbox.checked = false;
            }
          }
          
          updateAllergies();
        };
        
        allergyCheckboxes.forEach(checkbox => 
          checkbox.addEventListener('change', handleAllergyChange)
        );
        
        updateAllergies();
      }

      emailField() {
        if (!this.step7) return;

        let emailField = this.step7.querySelector('.js-subscription-email-field');
        let nextStepBtn = this.step7.querySelector('.js-next-button');

        if (!emailField) return;
        
        emailField.addEventListener('input', () => {
          let email = emailField.value.trim();
          let isValid = this.validateEmail(email);
          if (isValid) this.subscriptionData["Email"] = email;

          if(this.step7.classList.contains('error-present') && isValid){
            this.removeError(this.step7);
          }

          // if(window.matchMedia('(max-width: 999px)').matches && isValid && nextStepBtn) {
          //   emailField.addEventListener('keydown', (event) => {
          //     if (event.key === "Enter") {
          //       let nextSlide = nextStepBtn.getAttribute('data-next');
          //       setTimeout(() => {
          //         let nextStep = document.querySelector(`.js-slider-dots[data-dot-index="${nextSlide}"]`);
          //         if (nextStep) nextStep.click();
          //       }, 400);
          //     }
          //   }, { once: true });
          // }
        });

        if(window.matchMedia('(max-width: 999px)').matches) {
          this.handleNewsletter('.js-newsletter-checkbox');
        }
      }

      validateEmail(email) {
        let emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
      }

      submitSubscribeEmail() {
        let getEmail = this.subscriptionData["Email"];
        let action = '/contact?';
        let locale = this.currentQuiz;
        // if(this.currentQuiz == "subscription-puppy") {
        //   locale = 'Puppy';
        // }
        // else if(this.currentQuiz == "subscription-chewer") {
        //   locale = 'Chewer';
        // }
        // else if(this.currentQuiz == "subscription-combo") {
        //   locale = 'Combo';
        // }
        // else {
        //   locale = 'Regular';
        // }

        const isFrenchSite =
        window.location.hostname.includes("fr.") ||
        window.location.pathname.toLowerCase().startsWith("/fr"); 

        locale = isFrenchSite === "fr.woofpacks.ca" ? locale + '-FR' : locale + '-EN';
      
        let formData = new URLSearchParams();
        formData.append('form_type', 'customer');
        formData.append('utf8', '✓');
        formData.append('contact[email]', getEmail);
        formData.append('contact[tags]', 'newsletter');
        formData.append('contact[tags]', locale);
      
        fetch(action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: formData.toString()
        })
        .then(response => response.text())
        .then(responseText => {
          console.log(responseText);
        })
        .catch(error => {
          console.error('Request failed:', error);
        });
      }

      updatePlans() {
        if (!this.step8) return;
          window.setGridHeight('.js-subscription-plan .subscription-step-plan-product');
                        
        let subscriptionPlans = this.step8.querySelectorAll('.js-subscription-plan');
        let nextStepBtn = this.step8.querySelector('.js-next-button');

        if (!subscriptionPlans.length) return;
      
        subscriptionPlans.forEach((plan) => {
          let planCollectionSize = plan.getAttribute('data-size');
      
          if (this.bundleCollectionSize && planCollectionSize !== this.bundleCollectionSize) {
            plan.classList.add('hide');
          } else if (this.bundleCollectionSize !== "") {
            plan.classList.remove('hide');
          }
      
          if (!plan.dataset.listenerAdded) {
            plan.addEventListener('click', () => {
              this.planVariantId = plan.getAttribute('data-plan-id');
              this.sellingPlanId = plan.getAttribute('data-selling-plan');
      
              subscriptionPlans.forEach((subPlan) => subPlan.classList.remove('plan-selected'));
              plan.classList.add('plan-selected');
      
              if (this.step8.classList.contains('error-present')) {
                this.removeError(this.step8);
              }
      
              this.addGift = plan.getAttribute('data-gift-available');
      
              // if (window.matchMedia('(max-width: 999px)').matches && nextStepBtn) {
              //   setTimeout(() => {
              //     let nextSlide = nextStepBtn.getAttribute('data-next');
              //     document.querySelector(`.js-slider-dots[data-dot-index="${nextSlide}"]`)?.click();
              //   }, 400);
              // }
            });
      
            plan.dataset.listenerAdded = "true";
          }
        });
      }

      selectExtra() {
        if (!this.step9) return;
        
        let extraProducts = this.step9.querySelectorAll('.js-extra-product-container');
        
        if (!extraProducts.length) return;
        
        extraProducts.forEach((product) => {
          product.addEventListener('click', () => {
            product.classList.toggle('selected-extra-product');
          });
        });
      }

      handleNewsletter(className) {
        let newsletterCheckbox = document.querySelector(className);
        if (!newsletterCheckbox) return;
        
        this.subscriptionData["Newsletter subscribed"] = newsletterCheckbox.checked;
        newsletterCheckbox.addEventListener('change', () => {
          this.subscriptionData["Newsletter subscribed"] = newsletterCheckbox.checked;
        });
      }

      async getCartData() {
        let cart = await fetch('/cart.js').then(res => res.json());
        return cart;
      }

      async handleSubmit(e) {
        e.preventDefault();
        let cartData = await this.getCartData();
        let errorSteps = [];

        let firstStepBoxes = this.step1?.querySelectorAll('.js-box-type') || [];
        let anyStepBoxActive = Array.from(firstStepBoxes).some(stepBox => stepBox.classList.contains('box-active'));

        let sizeBoxes = this.step3?.querySelectorAll('.js-bundle-size') || [];
        let anySizeActive = Array.from(sizeBoxes).some(box => box.classList.contains('size-box-active'));

        if (!anyStepBoxActive && this.step1) {
            this.showError(this.step1);
            errorSteps.push({ elem: this.step1, step: parseInt(this.step1.getAttribute('data-index')) });
        }
        // if (!this.subscriptionData["Pup's Name"] && this.step2) {
        //     this.showError(this.step2);
        //     errorSteps.push({ elem: this.step2, step: parseInt(this.step2.getAttribute('data-index')) });
        // }
        if(this.step2.length > 0){
          this.step2.forEach((step) => {
            if(step.getAttribute('data-compulsory-question') == 'true' && step.querySelector('.js-input-quiz-field').value.trim() == "") {
              this.showError(step);
              errorSteps.push({ elem: step, step: parseInt(step.getAttribute('data-index')) });
            }
          })
        }
        if (!anySizeActive && this.step3) {
            this.showError(this.step3);
            errorSteps.push({ elem: this.step3, step: parseInt(this.step3.getAttribute('data-index')) });
        }
        // if (!this.subscriptionData["Breed Type"] && this.step4) {
        //     this.showError(this.step4);
        //     if (!firstErrorElem) firstErrorElem = this.step4;
        // }
        // if (this.subscriptionData["Dog's Dob"] == "" && this.step5) {
        //     this.showError(this.step5);
        //     if (!firstErrorElem) firstErrorElem = this.step5;
        // }
        if (!this.subscriptionData["Email"] && this.step7) {
            this.showError(this.step7);
            errorSteps.push({ elem: this.step7, step: parseInt(this.step7.getAttribute('data-index')) });
        }
    
        let allSubscriptionPlans = this.step8?.querySelectorAll('.js-subscription-plan') || [];
        let errorFree = Array.from(allSubscriptionPlans).some(el => el.classList.contains('plan-selected'));
        if (!errorFree && this.step8) {
            this.showError(this.step8);
            errorSteps.push({ elem: this.step8, step: parseInt(this.step8.getAttribute('data-index')) });
        }
    
        if(errorSteps.length > 0) {

          errorSteps.sort((a, b) => a.step - b.step);
          const firstErrorElem = errorSteps[0].elem;
          
          if(window.matchMedia('(max-width: 999px)').matches){
            let slideToIndex = firstErrorElem.getAttribute('data-index');
            let slide = document.querySelector(`.js-slider-dots[data-dot-index="${slideToIndex}"]`);
            if(slide) slide.click();
          }
          else{
            firstErrorElem.scrollIntoView({ behavior: "smooth", block: "start" });
          }
          return;
        }

        this.submitSubscribeEmail();

        this.subscriptionData['_subscription_product'] = 'true';
try {
  this.subscriptionData['_gift_eligible'] = this.addGift == "true" ? 'true' : 'false';
  let currentUrl = window.location.href.toLowerCase();
  this.subscriptionData['_gift_type'] = currentUrl.includes('chewer') ? 'durable' : 'regular';
} catch(e) {
  this.subscriptionData['_gift_eligible'] = 'false';
  this.subscriptionData['_gift_type'] = 'regular';
}
        let items = [
          {
            'id': this.planVariantId,
            'quantity': 1,
            'selling_plan': this.sellingPlanId,
            'properties': this.subscriptionData
          }
        ];

        let selectedExtras = this.querySelectorAll('.selected-extra-product');
        if(selectedExtras.length > 0){
          selectedExtras.forEach((product) => {
            let extraId = product.getAttribute('data-extra-product-id');
            let prodSellingPlan = product.getAttribute('data-selling-plan') || '';
            if (extraId && prodSellingPlan && prodSellingPlan != '') {
              items.push({
                id: extraId,
                quantity: 1,
                selling_plan: prodSellingPlan
              });
            }
            else if (extraId) {
              items.push({
                id: extraId,
                quantity: 1
              });
            }
          });
        }

        // if (this.extraProductId) {
        //   items.push({
        //     'id': this.extraProductId,
        //     'quantity': 1
        //   });
        // }

try {
  let currentUrl = window.location.href.toLowerCase();
  let giftElement = currentUrl.includes('chewer')
    ? this.querySelector('.js-sub-free-gift-durable')
    : this.querySelector('.js-sub-free-gift');

  if (giftElement && this.addGift == "true") {
    let giftProductId = parseInt(giftElement.getAttribute('data-gift-id'), 10);
    let giftType = giftElement.getAttribute('data-gift-type') || 'regular';
    let isGiftAlreadyInCart = cartData.items.some(item => item.variant_id === giftProductId);
    if (giftProductId && !isGiftAlreadyInCart) {
      items.push({
        'id': giftProductId,
        'quantity': 1,
        'properties': {
          '_subscription_free_gift': 'true',
          '_free_gift_type': giftType
        }
      });
    }
  }
} catch(e) {
  console.error('Free gift add error:', e);
}
        
        let formData = { 'items': items };
    
        try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            });
            const data = await response.json();
            console.log("Cart Response:", data);
            const isFrenchSitecart =
              window.location.hostname.includes("fr.") ||
              window.location.pathname.toLowerCase().startsWith("/fr");
            window.location.href = isFrenchSitecart ? "/fr/cart" : "/cart";
        } catch (error) {
            console.error('Error adding to cart:', error);
        }
      }


      showError(elem) {
        elem.classList.add('error-present');
        elem.style.border = "2px solid red";
      }

      removeError(elem) {
        if(elem.classList.contains('error-present')) elem.classList.remove('error-present');
        elem.style.border = "";
      }

      mobileBundleInit() {
        this._scrollArea = this.querySelector(".scroll-area");
        this.items = Array.from(this.querySelectorAll(".js-subscription-item"));
        this.prevButton = document.querySelector("[is='prev-button']");
        this.nextButton = document.querySelector("[is='next-button']");
        this.dotsContainer = document.querySelector(".js-dots-container");
    
        this.createDots();
    
        this.items.forEach((item, index) => {
          item.classList.toggle("active_div", index === 0);
          item.classList.toggle("hide", index !== 0);
        });
    
        this.prevButton.addEventListener("click", () => this.select(this.selectedIndex - 1));
        this.nextButton.addEventListener("click", () => this.select(this.selectedIndex + 1));
    
        this.updateButtons();
        this.updateDots();
      }

      createDots() {
        this.dotsContainer.innerHTML = "";
        this.items.forEach((_, index) => {
          const dot = document.createElement("span");
          dot.classList.add("dot", "js-slider-dots");
          dot.setAttribute('data-dot-index', index + 1);
          dot.addEventListener("click", () => this.select(index));
          this.dotsContainer.appendChild(dot);
        });
      }
    
      select(index) {
        if (index < 0 || index >= this.items.length) return;
    
        this.items.forEach((item) => {
          item.classList.remove("active_div");
          item.classList.add("hide");
        });
    
        this.items[index].classList.add("active_div");
        this.items[index].classList.remove("hide");

        if(index == (this.items.length - 1)) {
          if(this.submitButton.classList.contains('hide')) this.submitButton.classList.remove('hide');
        }
        else {
          if(!this.submitButton.classList.contains('hide')) this.submitButton.classList.add('hide');
        }
        
        this.selectedIndex = index;
        this.updateButtons();
        this.updateDots();
        this.scrollToActive();
      }
    
      updateButtons() {
        this.prevButton.disabled = this.selectedIndex === 0;
        this.nextButton.disabled = this.selectedIndex === this.items.length - 1;
      }
    
      updateDots() {
        const dots = this.dotsContainer.querySelectorAll(".dot");
        dots.forEach((dot, index) => {
          dot.classList.toggle("active", index === this.selectedIndex);
        });
      }
    
      scrollToActive() {
        const activeItem = this.items[this.selectedIndex];
        if (activeItem) {
          activeItem.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
        }
      }
      
    }
  );
}
